import React, { useState, useEffect } from "react";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { HiOutlineVideoCamera } from "react-icons/hi";
import { IoChatbubbleEllipsesOutline, IoClose, IoCheckmark } from "react-icons/io5";
import Button from "@material-ui/core/Button";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { cancelSlot, postFeedback, sendReminder, setTaskComplete } from "../../actions/bookSlot";
import "./index.css";
import { BsInfoCircle } from "react-icons/bs";
import Alert from "@material-ui/lab/Alert";
import { Tooltip } from "antd";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Rating from "@material-ui/lab/Rating";
import CheckIcon from "@material-ui/icons/Check";
import Snackbar from "@material-ui/core/Snackbar";
import { Rate } from "antd";
import { Link, useHistory } from "react-router-dom";
import { FaRegCalendarAlt, FaRegClock } from "react-icons/fa";
import BookingsIcon from "assets/svg_icons/bookings_icon_colored.svg";
import ClockIcon from "assets/svg_icons/clock_icon.svg";
import CalendarLarge from "assets/svg_icons/calendar_large.svg";
import ButtonBg from "assets/svg_icons/button-bg.svg";
import { motion } from "motion/react";

import {
  useIsFeatureEnabled,
  useUserInfoSelector,
  useUserTokenSelector,
} from "store/reducers";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "store/actions";
import SessionFeedbackPopup from "../../components/SessionFeedbackPopup/SessionFeedbackPopup";
import { fetchLatestBooking, fetchUserBookings } from "actions/dataLoad";
import { RiArrowDropDownLine, RiArrowDropUpLine } from "react-icons/ri";
import UserBookingsSkeleton from "./UserBookingsSkeleton";

const monthOptions = [
  { name: "All", fullName: "All Months", value: "all"},
  { num: 1, name: "Jan", fullName: "January" , value: "01"},
  { num: 2, name: "Feb", fullName: "February", value: "02" },
  { num: 3, name: "Mar", fullName: "March", value: "03" },
  { num: 4, name: "Apr", fullName: "April", value: "04" },
  { num: 5, name: "May", fullName: "May" , value: "05"},
  { num: 6, name: "June", fullName: "June", value: "06" },
  { num: 7, name: "July", fullName: "July", value: "07" },
  { num: 8, name: "Aug", fullName: "August", value: "08" },
  { num: 9, name: "Sep", fullName: "September", value: "09" },
  { num: 10, name: "Oct", fullName: "October", value: "10" },
  { num: 11, name: "Nov", fullName: "November", value: "11" },
  { num: 12, name: "Dec", fullName: "December", value: "12" },
];

export const UserBookings = ({
  showMessage,
  showError,
  onLatestBookingStatusChange,
}) => {
  const [cancelPopup, setCancelPopup] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("all");
  const [selectedYear, setSelectedYear] = useState("all");
  const [freeAllowedSessionReschedules, setFreeAllowedSessionReschedules] = useState(0);
  const [isFreecancellationAvailable, setIsFreecancellationAvailable] = useState(false);

  const [showOverlay, setShowOverlay] = useState(false);
  const [elementId, setElementId] = useState("");
  const [therapistId, setTherapistId] = useState("");
  const [bookingId, setBookingId] = useState("");
  const [upcomingBookings, setUpcomingBookings] = useState([]);
  const [completedBookings, setCompletedBookings] = useState([]);
  const userToken = useUserTokenSelector();
  const userInfo = useUserInfoSelector();
  const isMarketplaceEnabled = useIsFeatureEnabled("marketplace", "private");
  const [sessionFeedbackPopupState, setSessionFeedbackPopupState] = useState({ show: false, data: {} });
  const [selectedCategory, setSelectedCategory] = useState("upcoming");
  const [latestBooking, setLatestBooking] = useState(null);
  const [userFirstBookingYear, setUserFirstBookingYear] = useState("");
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  const [loading, setLoading] = useState(true);
  const shouldShowMarketplaceExplore =
    Number(userInfo?.categoryId) === 1 && isMarketplaceEnabled;

  const handleBookSessionNowClick = () => {
    if (shouldShowMarketplaceExplore && latestBooking?.therapistID) {
      history.push("/dashboard/sessionBooking", {
        fromMarketplace: true,
        marketplaceTherapist: {
          _id: latestBooking.therapistID,
          therapistName: latestBooking.therapistName,
          therapistImageUrl: latestBooking.therapistImageUrl,
          designation: latestBooking.therapistDesignation,
          experienceInYears: latestBooking.therapistExperienceInYears,
          specialities: (latestBooking.therapistExpertise || []).map((problemCategory) => ({
            problemCategory,
          })),
          languages: latestBooking.therapistLanguages || [],
          description: latestBooking.therapistBio || "",
          ratings: {
            average: latestBooking.therapistRating || 0,
            count: latestBooking.therapistRatingsCount || 0,
          },
          sessionsDoneCount: latestBooking.therapistSessionsDoneCount || 0,
          testimonials: latestBooking.therapistTestimonials || [],
        },
      });
      return;
    }

    history.push(
      shouldShowMarketplaceExplore ? "/dashboard/overview" : "/dashboard/sessionBooking"
    );
  };

  //loads all the therapy bookings of the user
  const getAllBookings = async (monthNumber, year = "") => {
    try {
      // dispatch(startLoading());
      setLoading(true);
      const apiParams = {
        timeOffset: new Date().getTimezoneOffset(),
        month: monthNumber,
        year: year,
        type: selectedCategory
      };

      const res = await fetchUserBookings(apiParams, userToken);

      const upcomingBookingsData = res.data?.["upcoming"] || [];
      const completedBookingsData = res.data?.["completed"] || [];
      const userTimestamp = res.data?.userTimestamp;
      const freeReschedules = res.data?.freeAllowedSessionReschedules ?? 0;
      const freeCancellation = res.data?.isFreecancellationAvailable ?? false;


      let i = 0;
      const processedCompletedBookings = completedBookingsData.map(booking => {
          let showRecommendation = false;
          if (!booking.isCancel && i < 2) {
              showRecommendation = true;
              i++;
          }
          return { ...booking, showRecommendation };
      });


      setUpcomingBookings(upcomingBookingsData);
      setCompletedBookings(processedCompletedBookings);
      setUserFirstBookingYear(userTimestamp);
      setFreeAllowedSessionReschedules(freeReschedules);
      setIsFreecancellationAvailable(freeCancellation);

    } catch (err) {
      console.error("Error fetching bookings:", err);
      showError(err?.response?.data?.error || "Failed to load bookings. Please try again.");
    } finally {
      // dispatch(stopLoading());
      setLoading(false);
    }
  };

  const sendRating = async (bookingID, rating, therapistID) => {
    try {
      // dispatch(startLoading());
      setLoading(true);
      await postFeedback({ bookingID, rating, therapistID }, userToken);
      await getAllBookings(selectedMonth, selectedYear);
      showMessage("Feedback submitted successfully!");
    } catch (err) {
      console.error("Error sending rating:", err);
      showError(err?.response?.data?.error || "Failed to submit feedback.");
    } finally {
      // dispatch(stopLoading());
      setLoading(false);
    }
  };

  const cancelBookingSlot = async () => {
    if (bookingId && therapistId) {
      try {
        const data = {
          bookingID: bookingId,
          therapistID: therapistId,
        };
        // dispatch(startLoading());
        setLoading(true);
        setIsCancelModalOpen(false);

        const res = await cancelSlot(data, userToken);

        if (res.data.isCancel) {
          showMessage(res.data.message || 'Booking cancelled successfully.');
          await getLatestBooking();
          setSelectedCategory("completed");
        } else {
          throw new Error(res.data?.error || 'Failed to cancel booking.');
        }
        setBookingId("");
        setTherapistId("");

      } catch (err) {
        console.error("Error cancelling booking:", err);
        showError(err?.response?.data?.error || err.message || "An error occurred while cancelling.");
        setIsCancelModalOpen(false);
        setBookingId("");
        setTherapistId("");
      } finally {
        // dispatch(stopLoading());
        setLoading(false);
      }
    } else {
        console.warn("Attempted to cancel booking without bookingId or therapistId.");
        setIsCancelModalOpen(false);
    }
  };

  const getLatestBooking = async () => {
    try {
      // dispatch(startLoading());
      setLoading(true);
      const response = await fetchLatestBooking(userToken);
      setLatestBooking(response.data?.upcoming || response.data?.latest || null);
      onLatestBookingStatusChange?.(
        (response.data?.latest || response.data?.upcoming)?.therapistID
      );
    } catch (error) {
      onLatestBookingStatusChange?.(false);
      showError(error.response?.data?.message || error.response?.data?.error || "Failed to load latest booking info.");
      console.error(error);
    } finally {
      // dispatch(stopLoading());
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllBookings(selectedMonth, selectedYear);
  }, [selectedMonth, selectedYear, selectedCategory]);

  useEffect(() => {
    getLatestBooking();
  }, []);

  const getMonthName = (monthNumber) => {
    const num = Number(monthNumber);
    if (num >= 1 && num <= 12) {
      // Use Intl.DateTimeFormat for locale-aware month names (optional but good practice)
      // const date = new Date();
      // date.setMonth(num - 1);
      // return date.toLocaleString('default', { month: 'short' }); // e.g., 'Jan', 'Feb'
      // Or use the existing array for consistency with dropdowns:
      const monthData = monthOptions.find(m => m.num === num);
      return monthData ? monthData.name : 'N/A';
    }
    return 'N/A';
  };

  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleSessionFeedbackSubmit = async ({ rating, sessionId, therapistId, message, comments }) => {
    try {
      setSessionFeedbackPopupState({ show: false, data: {} });
      // dispatch(startLoading());
      setLoading(true);
      await postFeedback({ rating, bookingID: sessionId, therapistID: therapistId, message, comments }, userToken);
      await getAllBookings(selectedMonth, selectedYear);
      showMessage("Feedback submitted successfully!");
    } catch (err) {
      console.error("Error submitting feedback:", err);
      showError(err?.response?.data?.error || "Failed to submit feedback.");
      // Optionally reopen popup or keep data if submission fails?
      // setSessionFeedbackPopupState({ show: true, data: { therapistName: sessionFeedbackPopupState.data.therapistName, therapistId, sessionId } });
    } finally {
      // dispatch(stopLoading());
      setLoading(false);
    }
  };

  const handleRating = ({ therapistName, therapistId, sessionId }) => {
    setSessionFeedbackPopupState({ show: true, data: { therapistName, therapistId, sessionId } });
  };

  const handleExpandBtnClick = (sessionId) => {
    const updater = (bookings) =>
      bookings.map((booking) =>
        booking._id === sessionId
          ? { ...booking, expanded: !booking.expanded }
          : booking
      );

    if (selectedCategory === "upcoming") {
      setUpcomingBookings(updater);
    } else if (selectedCategory === "completed") {
    }
  };

  // Calculate years array
  const hasCompletedBookings = completedBookings && completedBookings.length > 0;
  const earliestBookingYear = userFirstBookingYear && !isNaN(new Date(userFirstBookingYear))
      ? new Date(userFirstBookingYear).getFullYear()
      : currentYear;

  let years = [
      { label: "All times", value: "all" },
      ...Array.from({ length: currentYear - earliestBookingYear + 1 }, (_, i) => ({
        label: (earliestBookingYear + i).toString(),
        value: (earliestBookingYear + i).toString(),
      })),
    ];

  if (parseInt(currentMonth) === 12) {
    years = [...years, { label: (currentYear+1).toString(), value: (currentYear+1).toString() }]
  }
  
  const nextMonth = (parseInt(currentMonth) === 12) ? "01" : (parseInt(currentMonth) + 1).toString().padStart(2, '0');
 
   // Inside the MyBookings component
   const filteredMonths = (selectedCategory === "upcoming")
   ? [
       monthOptions[0], // Include 'All months'
       monthOptions.find((month) => month.value === currentMonth), // Include current month
       monthOptions.find((month) => month.value === nextMonth), // Include next month (handles December -> January correctly)
     ]
   : (selectedYear === currentYear.toString() || selectedYear === "all")
   ? [
       monthOptions[0], // Include 'All months'
       ...Array.from({ length: parseInt(currentMonth) }, (_, i) => {
         let monthValue = (parseInt(currentMonth) - i).toString().padStart(2, '0');
         return monthOptions.find((month) => month.value === monthValue);
       }).filter(Boolean), // Remove any undefined values
       monthOptions.find((month) => month.value === nextMonth)
     ]
   : [
       monthOptions[0], // Include 'All months'
       ...monthOptions.slice(1) // From January to December
     ];

  if (loading) {
    return <UserBookingsSkeleton />;
  }

  if (!latestBooking?._id) {
    // Show empty state if user has *never* booked a session
    return (
      <div className="scheduledashboard-empty">
        <div>
          <img src={CalendarLarge} alt="Calendar icon" />
          <div>You haven’t booked a session yet</div>
          <button onClick={handleBookSessionNowClick}>Book session now</button>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboardofboxes scheduledashboard">
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
          {error}
        </Alert>
      </Snackbar>

      <div className="usession-top">
        <div className="sessions-category">
          <button
            onClick={() => setSelectedCategory("upcoming")}
            className={`${selectedCategory === "upcoming" ? "active" : ""}`}
          >
            Upcoming Sessions
          </button>
          <button
            onClick={() => setSelectedCategory("completed")}
            className={`${selectedCategory === "completed" ? "active" : ""}`}
          >
            Completed Sessions
          </button>
        </div>
        <div className="session-filters">
          <div className={`session-filter`}>
            <select
              value={selectedMonth}
              onChange={(e) => {
                setSelectedMonth(e.target.value);
                if (e.target.value !== "all" && selectedYear === "all") {
                  setSelectedYear(currentYear.toString());
                } 
              }}
            >
              {filteredMonths.map((month) => (
                <option key={month.value} value={month.value}>{month.fullName}</option>
              ))}
            </select>
          </div>
          <div className={`session-filter`}>
            <select
              value={selectedYear}
              onChange={(e) => {
                setSelectedYear(e.target.value)
                if (e.target.value === "all" && selectedMonth !== "all") {
                  setSelectedMonth("all");
                }
              }}
            >
              {years.map((year) => (
                <option key={year.value} value={year.value}>
                  {year.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {selectedCategory === "upcoming" && (
        upcomingBookings.length > 0 ? (
          upcomingBookings.map((booking) => {
             const {
              isCancel = false,
              sessionTime = {},
              _id,
              reschedule = 0,
              therapistID,
              meetid,
              therapistName = "N/A",
              therapistImageUrl,
              therapistExpertise = [],
              therapistBio = "No bio available.",
              expanded = false,
              therapistTotalSessionMinutes = 0,
            } = booking;
            let { start, end } = sessionTime;

            let startDate = start ? new Date(start) : null;
            let endDate = end ? new Date(end) : null;
            let timeDifference = startDate ? startDate.getTime() - new Date().getTime() : -Infinity;
            let timeDifferenceEnd = endDate ? endDate.getTime() - new Date().getTime() : -Infinity;
            let displayDate = startDate ? startDate.getDate() : 'N/A';
            let displayMonth = startDate ? getMonthName(startDate.getMonth() + 1) : 'N/A';
            let displayStartTime = startDate ? startDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }) : 'N/A';
            let displayEndTime = endDate ? endDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }) : 'N/A';

            let in_progress = !isCancel && startDate && endDate && timeDifference <= 900000 && timeDifferenceEnd >= 0;
            let canBeRescheduled = !isCancel && startDate && reschedule < freeAllowedSessionReschedules && timeDifference > 3600000 * 10;
            let canBeCancelled = !isCancel && startDate && timeDifference > 0 && (timeDifference > 3600000 * 10 || isFreecancellationAvailable);


            return (
              <motion.div key={_id} initial={{ opacity: 0 }} animate={{ opacity: 1 }} className={`usession-div`}>
                <div className="usession-table">
                  <div className="usession-body">
                    <div className={`usession-container`}>
                      <div className="thname-value">
                        <img src={therapistImageUrl || "/images/therapist-demo.png"} alt={`${therapistName} profile`} />
                        <div className="name-div">
                          <p className="name">{therapistName}</p>
                          <p className="head">Therapist</p>
                        </div>
                      </div>
                      <div className="thsession-value">
                        <p className="combine">
                          <img src={BookingsIcon} alt="Date icon"/>
                          {displayDate} {displayMonth}
                        </p>
                        <p>
                          <img src={ClockIcon} alt="Time icon"/> {displayStartTime}-{displayEndTime}
                        </p>
                      </div>
                      {!isCancel && (
                        <div className="ubtns-div">
                          {in_progress && (
                            <div className="in-progress">
                              <button className={`upsession-btn in-progress join`}>
                                <Link
                                  to={{
                                    pathname: "/session/" + meetid,
                                    state: { therapistID, bookingID: _id },
                                  }}
                                  style={{ color: "inherit", textDecoration: "none" }}
                                >
                                  <div className="ujoin-div">
                                    <p>Join Now</p>
                                    <HiOutlineVideoCamera size={20} />
                                  </div>
                                </Link>
                              </button>
                            </div>
                          )}
                          {canBeCancelled && (
                            <Tooltip
                              placement="bottomLeft"
                              title={`Free cancellation is allowed ${isFreecancellationAvailable ? 'anytime before the session' : 'only if you cancel 10 hrs before the session start time'}.`}
                              color="#e8e8e8"
                              overlayInnerStyle={{ borderRadius: "10px", fontSize: "10px", color: "#000", fontWeight: "bold", maxWidth: "250px" }}
                            >
                              <button
                                onClick={() => {
                                  setIsCancelModalOpen(true);
                                  setBookingId(_id);
                                  setTherapistId(therapistID);
                                }}
                                className="upsession-btn cancel"
                              >
                                Cancel
                              </button>
                            </Tooltip>
                          )}
                          {canBeRescheduled && (
                            <Tooltip
                              placement="bottomLeft"
                              title={`You have ${freeAllowedSessionReschedules - reschedule} free reschedule(s) left. Rescheduling allowed up to 10 hours before the session.`}
                              color="#e8e8e8"
                              overlayInnerStyle={{ borderRadius: "10px", fontSize: "10px", fontWeight: "bold", color: "#000", width: "300px" }}
                            >
                              <button className="upsession-btn">
                                <Link
                                  to={{
                                    pathname: "/rescheduleSession",
                                    state: { therapistID, bookingID: _id },
                                  }}
                                  style={{ color: "inherit", textDecoration: "none" }}
                                >
                                  Reschedule
                                </Link>
                              </button>
                            </Tooltip>
                          )}
                        </div>
                      )}
                    </div>
                    <motion.div
                      initial={false}
                      animate={{ height: expanded ? 'auto' : 0, opacity: expanded ? 1 : 0 }}
                      transition={{ duration: 0.3 }}
                      style={{ overflow: 'hidden' }}
                      className={`usession-content`}
                    >
                      {therapistTotalSessionMinutes > 0 && (
                        <div><div>{therapistTotalSessionMinutes}+ mins of session experience</div></div>
                      )}
                      {therapistExpertise && therapistExpertise.length > 0 && (
                        <div>
                          <p>Specialization </p>
                          <div className="usession-content-tags">
                            {therapistExpertise.map((expertise, index) => (
                              <div key={index}>{expertise}</div>
                            ))}
                          </div>
                        </div>
                      )}
                      {therapistBio && (
                        <div>
                          <p>Bio</p>
                          <div className="usession-content-bio">{therapistBio}</div>
                        </div>
                      )}
                    </motion.div>

                    <div className="usession-btn-cont">
                      <button className="usession-btn" onClick={() => handleExpandBtnClick(_id)}>
                        View {expanded ? "less" : "more"}
                        {expanded ? <RiArrowDropUpLine size={24} /> : <RiArrowDropDownLine size={24} />}
                      </button>
                    </div>

                    {!isCancel && (
                        <div className="ubtns-div-mobile">
                          {in_progress && (
                            <div className="in-progress">
                              <button className={`upsession-btn in-progress join`}>
                                <Link
                                  to={{
                                    pathname: "/session/" + meetid,
                                    state: { therapistID, bookingID: _id },
                                  }}
                                  style={{ color: "inherit", textDecoration: "none" }}
                                >
                                  <div className="ujoin-div">
                                    <p>Join Now</p>
                                    <HiOutlineVideoCamera size={20} />
                                  </div>
                                </Link>
                              </button>
                            </div>
                          )}
                          {canBeCancelled && (
                            <Tooltip
                              placement="bottomLeft"
                              title={`Free cancellation is allowed ${isFreecancellationAvailable ? 'anytime before the session' : 'only if you cancel 10 hrs before the session start time'}.`}
                              color="#e8e8e8"
                              overlayInnerStyle={{ borderRadius: "10px", fontSize: "10px", color: "#000", fontWeight: "bold", maxWidth: "250px" }}
                            >
                              <button
                                onClick={() => {
                                  setIsCancelModalOpen(true);
                                  setBookingId(_id);
                                  setTherapistId(therapistID);
                                }}
                                className="upsession-btn cancel"
                              >
                                Cancel
                              </button>
                            </Tooltip>
                          )}
                          {canBeRescheduled && (
                             <Tooltip
                              placement="bottomLeft"
                              title={`You have ${freeAllowedSessionReschedules - reschedule} free reschedule(s) left. Rescheduling allowed up to 10 hours before the session.`}
                              color="#e8e8e8"
                              overlayInnerStyle={{ borderRadius: "10px", fontSize: "10px", fontWeight: "bold", color: "#000", width: "300px" }}
                            >
                              <button className="upsession-btn">
                                <Link
                                  to={{
                                    pathname: "/rescheduleSession",
                                    state: { therapistID, bookingID: _id },
                                  }}
                                  style={{ color: "inherit", textDecoration: "none" }}
                                >
                                  Reschedule
                                </Link>
                              </button>
                            </Tooltip>
                          )}
                        </div>
                      )}
                  </div>
                </div>
              </motion.div>
            );
          })
        ) : (
          <div className="empty-upcoming">
            <img src={CalendarLarge} alt="Calendar icon" />
            <div>
              No upcoming bookings found for this time period. <br /> Let's plan your next session!
            </div>
            <button onClick={handleBookSessionNowClick}>Book session now</button>
          </div>
        )
      )}

      {selectedCategory === "completed" && (
        completedBookings.length > 0 ? (
          completedBookings.map((booking) => {
             const {
                sessionTime = {},
                _id,
                isCancel = false,
                therapistImageUrl,
                therapistName = "N/A",
                rating,
                therapistID,
             } = booking;
             let { start, end } = sessionTime;

             let startDate = start ? new Date(start) : null;
             let endDate = end ? new Date(end) : null;
             let displayDate = startDate ? startDate.getDate() : 'N/A';
             let displayMonth = startDate ? getMonthName(startDate.getMonth() + 1) : 'N/A';
             let displayStartTime = startDate ? startDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }) : 'N/A';
             let displayEndTime = endDate ? endDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }) : 'N/A';

            return (
              <motion.div key={_id} initial={{ opacity: 0 }} animate={{ opacity: 1 }} className={`usession-div`}>
                <div className="usession-table">
                  <div className="usession-body">
                    <div className={`usession-container`}>
                      <div className="thname-value">
                        <img src={therapistImageUrl || "/images/therapist-demo.png"} alt={`${therapistName} profile`} />
                        <div className="name-div">
                          <p className="name">{therapistName}</p>
                          <p className="head">Therapist</p>
                        </div>
                      </div>
                      <div className="thsession-value">
                        <p className="combine">
                          <img src={BookingsIcon} alt="Date icon"/>
                          {displayDate} {displayMonth}
                        </p>
                        <p>
                          <img src={ClockIcon} alt="Time icon"/> {displayStartTime}-{displayEndTime}
                        </p>
                      </div>
                      <div className="completed" style={{backgroundColor:'transparent'}}>
                        {isCancel ? (
                          <div className="completed-cancelled">
                            <IoClose size={20} fill="#F45E4B" /> <span>Cancelled</span>
                          </div>
                        ) : (
                          <div className="completed-active">
                            <IoCheckmark size={20} fill="#49AF7C" /> <span>Completed</span>
                          </div>
                        )}
                      </div>
                      {!isCancel && (
                        <div className="feedback-section">
                          {rating ? (
                            <div className="rating-display">
                                <Rate disabled defaultValue={rating} style={{ fontSize: 16 }}/>
                                {/* Optionally allow re-rating? */}
                                {/* <button onClick={() => handleRating({ therapistName, therapistId: therapistID, sessionId: _id })}>Rate Again</button> */}
                            </div>
                          ) : (
                            <button
                              className="upsession-btn feedback-btn"
                              onClick={() => handleRating({ therapistName, therapistId: therapistID, sessionId: _id })}
                            >
                              Give Feedback
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                     {/* Optionally add expandable section for completed details if needed */}
                     {/* <motion.div ... > ... </motion.div> */}
                     {/* <div className="usession-btn-cont"> ... </div> */}
                  </div>
                </div>
              </motion.div>
            );
          })
        ) : (
          <div className="empty-upcoming">
            <img src={CalendarLarge} alt="Calendar icon" />
            <div>No completed sessions found for the selected period.</div>
          </div>
        )
      )}

      {isCancelModalOpen && (
        <div className="user-modal">
          <div className="signout-modal">
            <p className="signout-head">Are you sure you want to cancel this session?</p>
            <div className="sbtns">
              <button className="signout-btn" onClick={cancelBookingSlot}>Yes</button>
              <button className="signout-btn no" onClick={() => setIsCancelModalOpen(false)}>No</button>
            </div>
          </div>
        </div>
      )}

      {showOverlay && (
        <div
          className="popup-payment-alert-overaly"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: 9997 }}
          onClick={() => {
            setShowOverlay(false);
            setElementId("");
          }}
        ></div>
      )}

      <SessionFeedbackPopup
        isOpen={sessionFeedbackPopupState.show}
        onClose={() => setSessionFeedbackPopupState({ show: false, data: {} })}
        onSessionRatingSubmit={handleSessionFeedbackSubmit}
        sessionData={sessionFeedbackPopupState.data}
      />
    </div>
  );
};

export default UserBookings;
